var _ = require("../uam/fields.module.js")(module.exports, {
  namespace: "dashboard.schema",
  title: "Dashboard Schema",
  description: "Dashboard behavior and access configuration for schema-driven dashboards.",
  type: "field",
  use: {
    namespace: "ua.fields.schema.editor"
  },
  fields: {
    enabled: {
      title: "Enabled",
      description: "When false, no dashboard is generated for this schema.",
      type: "boolean",
      default: true
    },
    requiredRole: {
      title: "Required Role",
      description: "Minimum role required to access this dashboard. Default is no access.",
      type: "string",
      default: "__none__"
    },
    categories: {
      title: "Categories",
      description: "Dashboard navigation categories (my-settings, all-dashboards, build, design, reach, hustle). Maximum 2 categories.",
      type: "list",
      of: "string",
      default: ["build"]
    },
    subcategories: {
      title: "Subcategories",
      description: "Optional subcategories aligned by category index. Use one entry per category; defaults are category-aware (for build: workspace).",
      type: "list",
      of: "string",
      default: ["workspace"]
    },
    icon: {
      title: "Icon",
      description: "Bootstrap icon class suffix.",
      type: "string",
      default: "bi-table"
    },
    order: {
      title: "Order",
      description: "Navigation order in dashboard lists.",
      type: "number",
      default: 200
    },
    filters: {
      title: "Filters",
      description: "Schema field keys that can be filtered in list view.",
      type: "list",
      of: "string"
    },
    searchFields: {
      title: "Search Fields",
      description: "Schema field keys used in search queries.",
      type: "list",
      of: "string"
    },
    pageSize: {
      title: "Page Size",
      description: "Default list page size.",
      type: "number",
      default: 25
    }
  },
  errors: {
    invalid: {
      title: "Invalid Dashboard Schema",
      description: "Dashboard configuration must be an object."
    }
  }
});

function validate(spec, value) {
  if (value === undefined || value === null) return;
  if (typeof value !== "object" || value instanceof Array) {
    _.errors.invalid.throw();
  }
}
module.exports.validate = validate;
